import React, { FunctionComponent } from 'react'
import { useFormContext } from 'react-hook-form'
import { Input, InputOnChange, InputOnFocus } from '@afterpaytouch/core'
import { DateFieldSchema } from '../../types'
import { useDate } from '../../utils/date'
import { useError, useVisible } from '../../utils/hooks'

export const DateField: FunctionComponent<DateFieldSchema> = ({ name = '', props, options, show = true, format = 'MM/YYYY', testNameSpace = '' }) => {
  const { register, setValue } = useFormContext()
  const { isVisible, values } = useVisible({ name, show })
  const { isError, errorText } = useError({ name, error: props?.error, errorText: props?.errorText })
  const { parseFormattedDateString, parseISODateString } = useDate(format)
  const { formattedDate, isoDate } = parseISODateString(props?.value ?? '')
  const component = register(name, {
    ...options,
    value: values ?? isoDate,
  })

  const handleChange = (e: InputOnChange): void => {
    const { isoDate } = parseFormattedDateString(e.target.value)
    setValue(name, isoDate, {
      shouldValidate: false,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  const handleBlur = (e: InputOnFocus): void => {
    const { isoDate } = parseFormattedDateString(e.target.value)
    setValue(name, isoDate, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  return isVisible ? (
    <Input.Tel
      {...props}
      value={formattedDate}
      key={`${name}-${format}`}
      ref={component.ref}
      name={component.name}
      testNameSpace={testNameSpace}
      onChange={handleChange}
      onBlur={handleBlur}
      format={format.replace(/D|M|Y/gi, '0')}
      error={isError}
      errorText={errorText}
      fullWidth
    />
  ) : null
}
